var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _circle7, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 201,
    viewBox: "0 0 200 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100.93,
    r: 100,
    fill: "url(#paint0_linear_531_18042)",
    fillOpacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100.93,
    r: 99.8236,
    stroke: "url(#paint1_linear_531_18042)",
    strokeOpacity: 0.18,
    strokeWidth: 0.352734,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.176,
    cy: 101.105,
    r: 79.9296,
    fill: "url(#paint2_linear_531_18042)",
    fillOpacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.176,
    cy: 101.105,
    r: 79.7508,
    stroke: "url(#paint3_linear_531_18042)",
    strokeOpacity: 0.18,
    strokeWidth: 0.357627,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.176,
    cy: 101.104,
    r: 59.1549,
    fill: "url(#paint4_linear_531_18042)",
    fillOpacity: 0.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.176,
    cy: 101.104,
    r: 59.0017,
    stroke: "url(#paint5_linear_531_18042)",
    strokeOpacity: 0.18,
    strokeWidth: 0.306502,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1338 89.1932C30.6562 88.1406 57.2936 72.6991 57.2936 72.6991L76.8189 61.0603C78.2624 60.1998 80.1312 60.6929 80.9623 62.1535L90.3861 78.7146L117.907 125.701C118.93 127.446 118.929 128.229 116.54 129.628L69.095 157.418C67.5584 158.318 65.8529 158.535 64.8304 156.79C63.8079 155.044 28.3992 94.91 27.5958 93.2201C26.7923 91.5302 27.6114 90.2459 29.1338 89.1932Z",
    fill: "white",
    stroke: "#6C757D",
    strokeOpacity: 0.12,
    strokeWidth: 0.474687,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.05 63.7989L152.253 80.2194L172.285 91.4755C173.768 92.3086 174.262 94.2064 173.374 95.657L161.365 115.278C161.365 115.278 136.318 154.1 135.124 156.151C133.93 158.202 133.189 158.686 130.797 157.293L83.2851 129.63C83.2677 129.62 83.2762 129.616 83.2704 129.597L81.976 125.235C81.9696 125.213 81.9574 125.214 81.9694 125.195C82.3757 124.544 118.365 66.8816 119.552 64.8419C120.746 62.7906 122.341 62.8037 124.05 63.7989Z",
    fill: "white",
    stroke: "#6C757D",
    strokeOpacity: 0.12,
    strokeWidth: 0.474687,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6182 65.9375H105.404H132.516C132.562 65.9375 132.6 65.9753 132.6 66.0218V93.3444V161.44C132.6 163.97 132.177 164.813 129.227 164.813H70.6182C68.7199 164.813 67.0342 163.97 67.0342 161.44C67.0341 158.91 67.0346 71.8405 67.0342 69.3107C67.0338 66.7808 68.5099 65.9375 70.6182 65.9375Z",
    fill: "white",
    stroke: "#6C757D",
    strokeOpacity: 0.12,
    strokeWidth: 0.505974,
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.502,
    cy: 128.344,
    r: 24,
    fill: "#1819B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.467 123.724C99.5367 123.654 99.6194 123.599 99.7106 123.561C99.8017 123.523 99.8994 123.504 99.998 123.504C100.097 123.504 100.194 123.523 100.285 123.561C100.377 123.599 100.459 123.654 100.529 123.724L103.529 126.724C103.599 126.794 103.654 126.877 103.692 126.968C103.73 127.059 103.749 127.157 103.749 127.255C103.749 127.354 103.73 127.452 103.692 127.543C103.654 127.634 103.599 127.717 103.529 127.786C103.459 127.856 103.377 127.911 103.285 127.949C103.194 127.987 103.097 128.006 102.998 128.006C102.899 128.006 102.802 127.987 102.711 127.949C102.62 127.911 102.537 127.856 102.467 127.786L100.748 126.066V131.755C100.748 131.954 100.669 132.145 100.528 132.286C100.388 132.426 100.197 132.505 99.998 132.505C99.7991 132.505 99.6083 132.426 99.4677 132.286C99.327 132.145 99.248 131.954 99.248 131.755V126.066L97.529 127.786C97.3882 127.927 97.1972 128.006 96.998 128.006C96.7989 128.006 96.6078 127.927 96.467 127.786C96.3262 127.645 96.2471 127.454 96.2471 127.255C96.2471 127.056 96.3262 126.865 96.467 126.724L99.467 123.724Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.609 121.017C96.1082 119.724 98.0204 119.01 100 119.004C104.035 119.004 107.385 122.004 107.749 125.872C110.137 126.21 112 128.209 112 130.663C112 133.357 109.753 135.504 107.031 135.504H93.6715C90.562 135.504 88 133.053 88 129.981C88 127.336 89.899 125.146 92.413 124.591C92.6275 123.297 93.46 122.007 94.609 121.017ZM95.5885 122.152C94.453 123.132 93.859 124.312 93.859 125.236V125.908L93.1915 125.982C91.096 126.211 89.5 127.932 89.5 129.981C89.5 132.181 91.345 134.004 93.6715 134.004H107.031C108.97 134.004 110.5 132.486 110.5 130.663C110.5 128.839 108.97 127.321 107.031 127.321H106.281V126.571C106.282 123.241 103.492 120.504 100 120.504C98.3798 120.51 96.8153 121.094 95.5885 122.152Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_531_18042",
    x1: 100,
    y1: 0.929688,
    x2: 100.176,
    y2: 101.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F7FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_531_18042",
    x1: 100,
    y1: 0.929688,
    x2: 105.115,
    y2: 103.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C757D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_531_18042",
    x1: 100.176,
    y1: 21.1758,
    x2: 100.176,
    y2: 97.0561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F7FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_531_18042",
    x1: 100.176,
    y1: 21.1758,
    x2: 100.176,
    y2: 105.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C757D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_531_18042",
    x1: 100.176,
    y1: 41.9492,
    x2: 100.176,
    y2: 118.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F7FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_531_18042",
    x1: 100.176,
    y1: 41.9492,
    x2: 100.176,
    y2: 107.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C757D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.e82a106cd6190aeee125152d3b897dc6.svg";
export { ForwardRef as ReactComponent };